import React from 'react';
import { Edit, ListButton, TopToolbar } from 'react-admin';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import StateRuleForm from './StateRuleForm';

const StateRuleActions = ({ basePath }) => (
  <TopToolbar>
    <ListButton
      basePath={basePath}
      label='ra.action.back'
      icon={<ChevronLeft />}
    />
  </TopToolbar>
);

const StateRuleEdit = (props) => {
  return (
    <Edit title=' ' {...props} actions={<StateRuleActions {...props} />}>
      <StateRuleForm />
    </Edit>
  );
};

export default StateRuleEdit;
